import { useCustomerListeners } from "components/CustomerModal/hooks";
import { CustomerModalKeys } from "components/CustomerModal/queryKeys";
import { useRealTimeTypedQuery } from "components/WebSocket/hooks";
import { ApiInstance } from "utils/Api";

export const useCustomerServiceDetailsQuery = (id: number) => {
  const listeners = useCustomerListeners(id);

  return useRealTimeTypedQuery({
    queryKey: CustomerModalKeys.customerWithServiceDetails,
    queryFn: async ({ endpoint, baseUrl }) => (await ApiInstance.post(endpoint, { id }, baseUrl)).data.customer,
    listeners
  });
};
